export default "__VITE_ASSET__dYtKzyYs__"